﻿class DrilldownMenu {
    constructor() {
        this.$elms = $(".drilldownMenu");
        this.$root = this.$elms.closest('.mainmenu');
        this.$parentLi = $('.mainmenu .mainmenu-item--hasChildren');
        global.globalData.drilldownActive = false;
        this.checkDrilldown();
        this.setEventListeners();
    }

    checkDrilldown() {
        if (!Foundation.MediaQuery.atLeast('xlarge') && global.globalData.drilldownActive == false) {
            $(document)
                .off('mouseenter', '.mainmenu-item--hasChildren')
                .off('mouseleave', '.mainmenu-item--hasChildren');
            this.$elms.each(function(i, elm) {
                this.init($(elm));
            }.bind(this));
        } else {
            this.destroy();
            $(document)
                .on('mouseenter', '.mainmenu-item--hasChildren', this.adjustMinHeight.bind(this))
                .on('mouseleave', '.mainmenu-item--hasChildren', this.removeHeight.bind(this));
            global.globalData.drilldownActive = false;
        }
    }

    init($elm) {
        this.setBackLinks($elm);
        global.globalData.drilldownActive = true;
    }

    setEventListeners() {
        $(window)
            .on('resize',this.checkDrilldown.bind(this));
    }

    setBackLinks($elm) {
        var $list = $($elm);

        var $originalLink = $list.closest('li').find('> a');
        var $originalLinkUrl = $originalLink.attr('href');

        $originalLink.addClass('drilldownMenu--hasSubDrilldown');

        $list.prepend(`<li><a class="drilldownMenu--firstItem" href="${$originalLinkUrl}">${$originalLink.text()}</a></li>`);
        $list.prepend(`<li><a class="drilldownMenu--back" href="#">Terug</a></li>`);
        $(document)
                .on('click', '.drilldownMenu--back', this.onBackClick.bind(this))
                .on('click', '.drilldownMenu--hasSubDrilldown', this.onLinkClick.bind(this));
    }

    //methods
    openSubList($subList, $upperLink) {
        if ($subList.length > 0) {
            //Move container to level
            $subList.addClass('drilldownMenu--isCurrent');
            this.$root.addClass('drilldown-isOpen');
            this.adjustHeight($subList);
        } else {
            window.location.href = $upperLink.attr('href');
        }
    }

    goBack($list) {
        $list.removeClass('drilldownMenu--isCurrent');
        this.$root.removeClass('drilldown-isOpen');
        var $parentList = $list.parents('ul');
        this.adjustHeight($parentList);
    }

    adjustHeight($list) {
        this.$root.css({ height: '' });
        $list.css('max-height', 'none');
        var realHeight = $list.height();
        $list.css('max-height', '');
        this.$root.height(realHeight);
    }

    removeHeight() {
        this.$root.css({ height: '' });
    }

    adjustMinHeight(event) {
        this.$root.css({ height: '' });
        var $target = $(event.target).closest('li').find('.drilldownMenu');
        $target.css('max-height', 'none');
        var realHeight = $target.height();
        $target.css('max-height', '');
        if(realHeight > this.$root.height())
            this.$root.height(realHeight);
    }

    onLinkClick(event)
    {
        event.preventDefault();

        var $target = $(event.target).closest('a');
        var $subList = $target.closest('li').find('> ul');

        this.openSubList($subList, $target);
    }


    onBackClick(event) {
        event.preventDefault();

        var $root = $(event.target).closest('.drilldownMenu--isCurrent');
        this.goBack($root);
    }

    destroy() {
        $(document)
            .off('click', '.drilldownMenu--back')
            .off('click', '.drilldownMenu--hasSubDrilldown');
        $('.drilldownMenu--firstItem, .drilldownMenu--back').parent().remove();
        $('.drilldownMenu').removeClass('drilldownMenu--isCurrent');
        //$('.drilldownMenu--hasSubDrilldown').removeClass('drilldownMenu--hasSubDrilldown');
        this.$root.removeClass('drilldown-isOpen').css({ height: '' });
    }
}

export default DrilldownMenu;